import type { UpdateSelectionAreaInPlan } from "./types";

export const updateSelectionAreaInPlan: UpdateSelectionAreaInPlan = ({
  plan,
  areaId,
  changes,
}) => ({
  ...plan,
  selectionAreas: plan.selectionAreas.map((area) =>
    area.id === areaId ? { ...area, ...changes } : area,
  ),
});
